import axios from 'axios';
import React from 'react'
import BaseUrl from "./base-api";
import { toast } from 'react-toastify';

const AxiosInstance = axios.create({
  baseURL: BaseUrl, // your Spring Boot backend
  headers: {
    'Content-Type': 'application/json',
  },
});

AxiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("userToken");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 Unauthorized globally
AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data;

    if (status === 401 && typeof data === 'string' && data.toLowerCase().includes('expired')) {
      // Show toast
      toast.error('Session expired. Redirecting to login...', {
        position: 'top-center',
        autoClose: 3500, // 3.5 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });

      // Remove token and redirect after delay
      setTimeout(() => {
        sessionStorage.removeItem("userToken");
        window.location.href = "/login";
      }, 2500);
    }

    return Promise.reject(error);
  }
);




export default AxiosInstance